if (!customElements.get('marquee-text')) {
  class MarqueeText extends HTMLElement {
    constructor() {
      super();
    }

    animationLoop(timestamp) {
      if (this.enablePause && this.stopped)
        return (this.rafId = window.requestAnimationFrame((timestamp) =>
          this.animationLoop(timestamp),
        ));

      const delta = timestamp - this.lastTime;
      const normalizedSpeed = (this.speed * delta) / 16;

      this.containerLeft = this.parentElement.getBoundingClientRect().left;
      const firstListItem = this.querySelector('*:first-child');
      let rightSideOfFirstItem = firstListItem.getBoundingClientRect().right;

      if (rightSideOfFirstItem <= this.containerLeft) {
        // this.currentLeft = -this.speed;
        this.currentLeft += firstListItem.offsetWidth;
        this.appendChild(firstListItem);
      }

      // this.style.marginLeft = `${Math.ceil(this.currentLeft)}px`;
      this.style.transform = `translate3d(${this.currentLeft}px, 0, 0)`;
      this.currentLeft -= normalizedSpeed;

      this.lastTime = timestamp;

      this.rafId = window.requestAnimationFrame((timestamp) => {
        this.animationLoop(timestamp);
      });
    }

    initialize() {
      this.containerLeft = this.parentElement.getBoundingClientRect().left;
      this.currentLeft = 0;
      this.stopped = false;
      this.speed = Number(this.dataset.speed) || 1;
      this.enablePause = this.hasAttribute('data-pause-on-hover');
      this.lastTime = performance.now();
    }

    restart() {
      this.currentLeft = 0;
      this.containerLeft = this.parentElement.getBoundingClientRect().left;
      this.stopped = false;
      this.lastTime = performance.now();

      cancelAnimationFrame(this.rafId);
      this.animationLoop(this.lastTime);
    }

    connectedCallback() {
      this.addEventListener('mouseenter', () => (this.stopped = true));
      this.addEventListener('mouseleave', () => (this.stopped = false));

      this.initialize();
      this.animationLoop(this.lastTime);
    }
  }

  customElements.define('marquee-text', MarqueeText);
}
